/* Manages text_align, text_transform, text_color and background_color */

/* global jQuery */

import { saveLabel } from "./persistence.js";
import { isCanadian } from "./format.js";

export const currentTextTransform = () => {
  if (jQuery("#make-titlecase-toggle").is(":checked")) {
    return "capitalize";
  } else if (jQuery("#make-lowercase-toggle").is(":checked")) {
    return "lowercase";
  } else if (jQuery("#remove-uppercase-toggle").is(":checked")) {
    return "none";
  } else {
    return "uppercase";
  }
};

export const currentTextAlign = () => {
  if (jQuery("#justify-left-toggle").is(":checked")) {
    return "left";
  } else if (jQuery("#justify-center-toggle").is(":checked")) {
    return "center";
  } else {
    return "justify";
  }
};

const applyTextTransform = (transform) => {
  jQuery(
    "#recipe-show-ingredient-list, #allergen-list, #recipe_manufactured_at, " +
      "#facility-allergen-list, .agg-ingredient-list, .agg-ingredient-list-recipe-name, " +
      ".agg-allergen-list, #bioengineered-claim"
  ).css("text-transform", transform);

  if (isCanadian()) {
    jQuery("#recipe_manufactured_at").css("text-transform", "none");
  }
};

const applyStandardText = () => {
  applyTextTransform("uppercase");
};

const removeUppercase = () => {
  jQuery("#make-lowercase-toggle, #make-titlecase-toggle").prop("checked", false);

  applyTextTransform("none");
};

const applyLowercase = () => {
  jQuery("#remove-uppercase-toggle, #make-titlecase-toggle").prop("checked", false);

  applyTextTransform("lowercase");
};

const applyTitlecase = () => {
  jQuery("#make-lowercase-toggle, #remove-uppercase-toggle").prop("checked", false);

  applyTextTransform("capitalize");
};

const applyAlignment = (alignment) => {
  jQuery(
    "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
      ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
      ".facility-allergen-list-canada-french, #recipe_manufactured_at, " +
      "#facility-allergen-list, .recipe-show-new-canada-ingredient-list, " +
      ".recipe-show-new-canada-french-ingredient-list, .agg-ingredient-list, " +
      ".agg-ingredient-list-recipe-name, .agg-allergen-list, " +
      ".ca-agg-ingredient-list-recipe-name, #bioengineered-claim"
  ).css("text-align", alignment);
};

const applyJustifyLeft = () => {
  jQuery("#justify-center-toggle").prop("checked", false);

  applyAlignment("left");
};

const applyJustifyCenter = () => {
  jQuery("#justify-left-toggle").prop("checked", false);

  applyAlignment("center");
};

const applyDefaultJustify = () => {
  applyAlignment("justify");
};

const applyTextColor = (color) => {
  // but not for canada labels, required to be black
  jQuery(
    "#newaspreparednutritionfactstable, #newlinearnutritionfactstable, newaggregatenutritionfactstable, " +
      "#linearnutritionfactstable, #newnutritionfactstable, #newdualnutritionfactstable, " +
      ".nutritionfactstable, #tabularnutritionfactstable, #newtabularnutritionfactstable, " +
      ".aggregatenutritionfactstable, #newinfantnutritionfactstable, " +
      "#newchildnutritionfactstable, #infantnutritionfactstable, #childnutritionfactstable, " +
      "#newaggregatenutritionfactstable"
  ).css("color", color);
  jQuery(
    ".dual-package-col, .dual-serving-col, .calories-tabular-div, " +
      ".new_tabular_dual_nutrient_col, .agg-package-col, .agg-left-col"
  ).css("border-color", color);

  // and change ingredient list, allergens, etc. colors
  // but not for canada labels, required to be black
  jQuery(
    "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
      ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
      ".facility-allergen-list-canada-french, #facility-allergen-list, #recipe_manufactured_at, " +
      ".agg-ingredient-list, .agg-ingredient-list-recipe-name, .agg-allergen-list, #bioengineered-claim"
  ).css("color", color);
  if (isCanadian()) {
    jQuery(
      ".allergen-list-canada-english, .allergen-list-canada-french, " +
        ".ca-agg-ingredient-list-recipe-name, " +
        ".facility-allergen-list-canada-english, .facility-allergen-list-canada-french, " +
        "#recipe_manufactured_at, #bioengineered-claim"
    ).css("color", "black");
  }
};

const applyBackgroundColor = (color) => {
  jQuery(
    "#newaspreparednutritionfactstable, #newlinearnutritionfactstable, #newaggregatenutritionfactstable, " +
      "#linearnutritionfactstable, #newnutritionfactstable, #newdualnutritionfactstable, " +
      ".dual-package-col, .dual-serving-col, .nutritionfactstable, " +
      "#tabularnutritionfactstable, #newtabularnutritionfactstable, " +
      ".aggregatenutritionfactstable, #newinfantnutritionfactstable, " +
      "#newchildnutritionfactstable, #infantnutritionfactstable, #childnutritionfactstable"
  ).css("background-color", color);
};

export const initializeTextControls = () => {
  // remove uppercase from extra sections
  jQuery("#remove-uppercase-toggle").on("click", () => {
    if (jQuery("#remove-uppercase-toggle").is(":checked")) {
      removeUppercase();
    } else {
      applyStandardText();
    }

    saveLabel({ text_transform: currentTextTransform() });
  });

  // make lowercase in extra sections
  jQuery("#make-lowercase-toggle").on("click", () => {
    if (jQuery("#make-lowercase-toggle").is(":checked")) {
      applyLowercase();
    } else {
      applyStandardText();
    }

    saveLabel({ text_transform: currentTextTransform() });
  });

  // make titlecase in extra sections
  jQuery("#make-titlecase-toggle").on("click", () => {
    if (jQuery("#make-titlecase-toggle").is(":checked")) {
      applyTitlecase();
    } else {
      applyStandardText();
    }

    saveLabel({ text_transform: currentTextTransform() });
  });

  // justify left
  jQuery("#justify-left-toggle").on("click", () => {
    if (jQuery("#justify-left-toggle").is(":checked")) {
      applyJustifyLeft();
    } else {
      applyDefaultJustify();
    }

    saveLabel({ text_align: currentTextAlign() });
  });

  // justify center
  jQuery("#justify-center-toggle").on("click", () => {
    if (jQuery("#justify-center-toggle").is(":checked")) {
      applyJustifyCenter();
    } else {
      applyDefaultJustify();
    }

    saveLabel({ text_align: currentTextAlign() });
  });

  jQuery("#regularlabel-textcolor-update").on("click", () => {
    applyTextColor(jQuery("#regularlabel-color").val());

    saveLabel({ text_color: jQuery("#regularlabel-color").val() });
  });

  jQuery("#regularlabel-textcolor-reset").on("click", () => {
    applyTextColor("black");

    jQuery("#regularlabel-color").val("black");

    saveLabel({ text_color: jQuery("#regularlabel-color").val() });
  });

  // Change label background color on click
  jQuery("#regularlabel-backgroundcolor-update").on("click", () => {
    applyBackgroundColor(jQuery("#regularlabel-backgroundcolor").val());

    saveLabel({ background_color: jQuery("#regularlabel-backgroundcolor").val() });
  });

  // Reset regular label background color to white on click
  jQuery("#regularlabel-backgroundcolor-reset").on("click", () => {
    applyBackgroundColor("white");

    jQuery("#regularlabel-backgroundcolor").val("white");

    saveLabel({ background_color: jQuery("#regularlabel-backgroundcolor").val() });
  });

  jQuery("#regularlabel-transparentbackground").on("click", (e) => {
    saveLabel({
      transparent_background: jQuery("#regularlabel-transparentbackground").is(":checked"),
    });
  });
};

export const applyTextStyles = (recipe_label) => {
  if (recipe_label.text_align === "left") {
    jQuery("#justify-left-toggle").trigger("click");
  } else if (recipe_label.text_align === "center") {
    jQuery("#justify-center-toggle").trigger("click");
  }

  if (recipe_label.text_transform === "none") {
    jQuery("#remove-uppercase-toggle").trigger("click");
  } else if (recipe_label.text_transform === "lowercase") {
    jQuery("#make-lowercase-toggle").trigger("click");
  } else if (recipe_label.text_transform === "capitalize") {
    jQuery("#make-titlecase-toggle").trigger("click");
  }
};

export const syncTextControlsWithLabel = () => {
  if (jQuery("#remove-uppercase-toggle").is(":checked")) {
    removeUppercase();
  } else if (jQuery("#make-lowercase-toggle").is(":checked")) {
    applyLowercase();
  } else if (jQuery("#make-titlecase-toggle").is(":checked")) {
    applyTitlecase();
  } else {
    applyStandardText();
  }

  if (jQuery("#justify-left-toggle").is(":checked")) {
    applyJustifyLeft();
  } else if (jQuery("#justify-center-toggle").is(":checked")) {
    applyJustifyCenter();
  } else {
    applyDefaultJustify();
  }

  applyTextColor(jQuery("#regularlabel-color").val());
  applyBackgroundColor(jQuery("#regularlabel-backgroundcolor").val());
};
